import { API } from "../../apiSlice";

export const getLoanScheduleApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    getLoanSchedule: builder.query({
      query: (loanId) => {
        return {
          url: `users/loan-schedule/${loanId}`,
        };
      },
    }),
  }),
});

export const { useGetLoanScheduleQuery } = getLoanScheduleApiSlice;
